<script setup lang="ts">
withDefaults(defineProps<{
    full?: boolean
}>(), {
    full: false
})
</script>

<template>
    <div class="stf-container" :class="{ 'stf-container--full-width': full }">
        <slot></slot>
    </div>
</template>

<style scoped>
.stf-container {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
}

.stf-container--full-width {
  max-width: none;
  padding: 0;
}
</style>
